// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"130":"route-login","557":"route-backtests","564":"route-strategies","632":"route-market-data","942":"route-backtest-legacy"}[chunkId] || chunkId) + "." + {"130":"3e7cfd7c","557":"7f25a8e2","564":"54d718d8","632":"58f1348e","934":"abf96be1","942":"ecd75008"}[chunkId] + ".css";
};